export default {"src":"/_next/static/media/carrots.f8f2178f.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};